import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40ee44c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "working-site-card mb-4 w-full" }
const _hoisted_2 = { class: "first-row grid grid-cols-2 gap-4" }
const _hoisted_3 = {
  key: 0,
  class: "special-toggle text-white bg-secondary-600 rounded-full px-2 py-1 w-40 right text-sm font-bold self-center"
}
const _hoisted_4 = {
  key: 1,
  class: "regular-toggle text-white bg-black rounded-full px-2 py-1 w-40 right text-sm font-bold self-center"
}
const _hoisted_5 = { class: "dates right leading-8 text-right text-sm font-bold" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "second-row" }
const _hoisted_10 = { class: "font-bold text-xl text-left pt-6" }
const _hoisted_11 = {
  key: 0,
  class: "address text-left pt-1"
}
const _hoisted_12 = { class: "third-row flex" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "p-2 font-bold border-2 cursor-pointer border-primary-600 rounded" }, "Vedi Cantiere", -1))
const _hoisted_14 = {
  key: 0,
  class: "customer flex align-items-center"
}
const _hoisted_15 = { class: "mr-6" }
const _hoisted_16 = {
  key: 1,
  class: "customer flex align-items-center"
}
const _hoisted_17 = { class: "mr-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ClientIconSmall = _resolveComponent("ClientIconSmall")!
  const _component_DocumentIconSmall = _resolveComponent("DocumentIconSmall")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.modelValue.isSpecialWorkingSite)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Cantiere Speciale"))
        : (_openBlock(), _createElementBlock("p", _hoisted_4, "Cantiere Tradizionale")),
      _createElementVNode("p", _hoisted_5, [
        (_ctx.modelValue.startTs)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.moment.unix(_ctx.modelValue.startTs).format('DD/MM/YY')), 1))
          : _createCommentVNode("", true),
        (_ctx.modelValue.startTs && _ctx.modelValue.endTs)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, " - "))
          : _createCommentVNode("", true),
        (_ctx.modelValue.endTs)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.moment.unix(_ctx.modelValue.endTs).format('DD/MM/YY')), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("h2", _hoisted_10, _toDisplayString(_ctx.modelValue.name), 1),
      (_ctx.modelValue.address)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_11, _toDisplayString(_ctx.modelValue.address.address), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      (_ctx.modelValue.customer)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createVNode(_component_ClientIconSmall, { class: "mr-1 small-path-blue" }),
            _createElementVNode("h2", _hoisted_15, _toDisplayString(_ctx.modelValue.customer), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.modelValue.orderNumber)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createVNode(_component_DocumentIconSmall, { class: "mr-1 small-path-blue" }),
            _createElementVNode("h2", _hoisted_17, _toDisplayString(_ctx.modelValue.orderNumber), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}